import React from 'react';
import factory from 'components/Icons/factory';

// Icons are built as 128x128 originals
export const Recipe = factory(
  'Recipe',
  <g>
    <path d="M116.4 10v108H11.6V10h104.8M128 0H0v128h128V0z" />
    <path d="M48 26h54v8H48z" />
    <circle cx="32" cy="30" r="8" />
    <path d="M48 60h54v8H48z" />
    <circle cx="32" cy="64" r="8" />
    <path d="M48 94h54v8H48z" />
    <circle cx="32" cy="98" r="8" />
  </g>
);

export default Recipe;
